import type { ConsentVersions } from '../types'

/**
 * Whether `version` asks a player who accepted `accepted` to accept again: general terms on a new major
 * version, the privacy policy on any newer one. Content front matter can carry the version as a number.
 */
export function isNewerConsentVersion(type: keyof ConsentVersions, accepted: string | undefined, version: string | number | null | undefined): boolean {
    if (!accepted || version == null || version === '') return false

    return type === 'general-terms'
        ? Number.parseInt(accepted) < Number.parseInt(String(version))
        : Number(accepted) < Number(version)
}
